var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flight_box_three"},[_c('box-three-child-app',{attrs:{"airlineNotConfirmed":_vm.airlineNotConfirmed,"image":_vm.airlineLogo,"total":_vm.totalPrice,"average":_vm.averagePrice,"infoFlight":_vm.infoFlight,"currencySymbol":_vm.product.cc,"occupancy":_vm.occupancy},on:{"emitBook":_vm.booking,"emitUpdatePax":_vm.updatePax}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }